// extracted by mini-css-extract-plugin
export default {"labelWidth10":"LabelLoader_labelWidth10__g-mtb","labelWidth15":"LabelLoader_labelWidth15__wZyd9","labelWidth20":"LabelLoader_labelWidth20__ptofN"};